module.exports = __webpack_public_path__ + "img/sensor_pairing_mode.6f5f8254.png";